import reasonsForClaimIntroPage from './reasonsForClaimIntroPage';
import veteranIncarcerationPage from './veteranIncarcerationPage';
import survivingSpouseIncarcerationPage from './survivingSpouseIncarcerationPage';
import veteranCompetencePage from './veteranCompetencePage';
import veteranSupportPage from './veteranSupportPage';
import beneficiaryRestrictedAreaPage from './beneficiaryRestrictedAreaPage';
import veteranMissingPage from './veteranMissingPage';
import importantInformationPage from './importantInformationPage';

export default {
  reasonsForClaimIntroPage,
  veteranIncarcerationPage,
  survivingSpouseIncarcerationPage,
  veteranCompetencePage,
  veteranSupportPage,
  beneficiaryRestrictedAreaPage,
  veteranMissingPage,
  importantInformationPage,
};
